import { getterTree } from 'typed-vuex';
import { Link } from '@/repositories/fo-manual-API/LinksRepository/types';
import initialState from './state';

const getters = getterTree(initialState, {
  links(state): Link[] {
    return state['hydra:member'];
  },
  totalItems(state): number {
    return state['hydra:totalItems'];
  },
  page(state): number {
    const viewId = state['hydra:view']?.['@id'];
    if (viewId) {
      const url = new URL(`http://baseurl${viewId}`);
      const param = url.searchParams.get('page');
      return param && Number.isNaN(+param) ? +param : 1;
    }
    return 1;
  },
  pageCount(state): number {
    const last = state['hydra:view']?.['hydra:last'];
    if (last) {
      const url = new URL(`http://baseurl${last}`);
      const param = url.searchParams.get('page');
      return param && Number.isNaN(+param) ? +param : 1;
    }
    return 1;
  },
});

export default getters;
